<template>
  <v-btn
    id="add-button-menu-plus-button"
    small
    color="primary"
    class="ml-2 mr-0 elevation-0"
    :class="{
      'pl-2': !isMobile,
    }"
    @click="click"
  >
    <v-icon :size="isMobile ? 22 : 20" class="add-button-plus-icon">mdi-plus</v-icon>
    <span v-if="!isMobile" class="ml-1">{{ text || $t('views.common.addButtons.new') }}</span>
  </v-btn>
</template>

<script>
export default {
  props: {
    click: {
      type: Function,
      required: true,
    },
    text: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
}
</script>

<style lang="scss">
#add-button-menu-plus-button {
  margin-top: 1px;
  // height: 33px;
}
.add-button-plus-icon {
  margin-bottom: 1px;
}
</style>
